<!--  -->
<template>
<div class='container' :style="`background-image:url(${require('@/assets/img/bg-2.jpg')})`">
<div class="back" @click="$router.go(-1)"><img src="@/assets/img/back-ico.png" alt=""></div>
<div class="avatar">
    <img class="photo" :src="require('@/assets/img/avatar'+author.id+'.png')" alt="">
    <span class="name">{{author.name}}</span>
</div>
<div class="content">
    <p v-for="(item,i ) in author.brief" :key="i">{{item}}</p>
</div>
<div class="work">
    <div class="tit"><img src="@/assets/img/work-title.png" alt=""></div>
    <div class="list" :style="`background-image:url(${require('@/assets/img/work-line.png')})`">
        <div class="swiper">
            <swiper :options="swiperOptions" class="swiperContainer" ref="swiper">
                <swiperSlide class="slide" v-for="(item,i) in author.works" :key="i"><div :class="['item','item'+i,{'odd':getMod(i)}]" @click="$router.push('/photo?m='+author.id+'&id='+i)">{{item}}</div></swiperSlide> 
                <div class="btn swiper-button-prev" slot="button-prev" ></div>
                <div class="btn swiper-button-next" slot="button-next"></div>               
            </swiper>
            <div class="btn swiper-button-prev" @click="slidePrev()" v-if="author.works.length>4"></div>
            <div class="btn swiper-button-next" @click="slideNext()"  v-if="author.works.length>4"></div>  
        </div>
       
    </div>
</div>

</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
//import引入的组件需要注入到对象中才能使用
components: {
    swiper,
    swiperSlide
},
data() {
//这里存放数据
return {
    authors:{
        '1':{
            id:1,
            name:'欧阳询',
            brief:['欧阳询（557—641年），字信本，潭州临湘（今湖南长沙）人，唐朝大臣、书法家，官至银青光禄大夫、给事中、太子率更令、弘文馆学士，封渤海县男，故也称为“欧阳率更”。','欧阳询书学“二王”，于平正中见险绝，自成一格，人称“欧体”，与虞世南、褚遂良、薛稷并称初唐四大家。又其楷书法度之严谨，笔力之险峻，世无所匹，被称之为唐人楷书第一。','唐代书法品评著作《书断》称：“询八体尽能，笔力劲险。篆体尤精，飞白冠绝，峻于古人，扰龙蛇战斗之象，云雾轻笼之势，几旋雷激，操举若神。真行之书，出于太令，别成一体，森森焉若武库矛戟，风神严于智永，润色寡于虞世南。其草书迭荡流通，视之二王，可为动色；然惊其跳骏，不避危险，伤于清之致。”'],
            works:[
               '九成宫醴泉铭碑','虞恭公温彦博碑','皇甫诞碑','房彦谦碑'
            ]
        },
        '2':{
            id:2,
            name:'颜真卿',
            brief:['颜真卿（709—784年），字清臣，京兆万年（今陕西西安）人，祖籍琅琊临沂（今山东临沂）。唐朝名臣、书法家，历任吏部尚书，太子太师，封鲁郡开国公，故又称颜鲁公。德宗时，藩镇将领李希烈叛乱，颜真卿亲赴敌营，晓以大义，终为李希烈缢杀。德宗诏文曰：“器质天资，公忠杰出，出入四朝，坚贞一志”。','在书法史上，他是继“二王”之后成就最高，影响最大的书法家。其书初学张旭，后广收博取，一变古法，自成一种方严正大，朴拙雄浑，大气磅礴的“颜体”。宋欧阳修评论说：“斯人忠义出于天性，故其字画刚劲独立，不袭前迹，挺然奇伟，有似其为人。宋朱长文《续书断》中列其书法为神品。”'],
            works:['多宝塔碑','东方画赞碑','臧怀恪碑','郭氏家庙碑','元结碑','八关斋会报德记碑','干禄字书碑','颜勤礼碑','颜家庙碑','争座位帖']
        },
        '3': {
            name:'柳公权',
            brief: ['柳公权（778－865年），字诚悬，京兆华原（今陕西铜川）人，唐代著名书法家。柳公权29岁时状元及第，共历仕七朝，官至太子少师，封河东郡公，以太子太保致仕，故世称“柳少师”。','柳公权书法初学王羲之，以后遍观唐代名家书法，吸取颜真卿、欧阳询之长，溶汇自己新意，然后自成一家，自创独树一帜的“柳体”，为后世百代楷模。他的字取匀衡瘦硬，追魏碑斩钉截铁势，点画爽利挺秀，骨力遒劲，结体严紧。他的楷书，较之颜体，则稍均匀瘦硬，故有“颜筋柳骨”之称。'],
            works: ['冯宿碑','符璘碑','玄秘塔碑','魏公先庙碑','高元裕碑','沂州普照寺碑']
        },
        '4': {
            id:4,
            name:'赵孟頫',
            brief: ['赵孟頫（1254—1322年），字子昂，浙江吴兴（今浙江湖州）人，元代著名书画家。赵孟頫博学多才，能诗善文，懂经济，工书法，精绘艺，擅金石，通律吕，解鉴赏。其书取法钟繇、“二王”、李邕、赵构等，于篆、隶、真、行、草诸体皆擅，尤以楷书、行书著称；其书风遒媚、秀逸，结体严整、笔法圆熟，创“赵体”书。'],
            works: ['赵书狄梁公碑','渔庄记碑','虎丘隆禅师碑','金刚经碑','投龙简记碑','大元敕藏御服之碑','寿春堂记碑','李彬碑','长明灯记碑','辉州重修玉虚观碑']
        },
    },
    author:{
        id:1,
        avatar:require('@/assets/img/avatar1.png'),
        brief:[],
        works:[]
    },
    swiperOptions:{
        slidesPerView: 4,
        // prevButton:'.swiper-button-prev',
        // nextButton:'.swiper-button-next',
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
    }
};
},
//监听属性 类似于data概念
computed: {
     swiper() {
        return this.$refs.swiper.swiper
      }
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    getMod(num){
        return (num%2)>0
    },
    slidePrev() {
        this.swiper.slidePrev();
    },
    slideNext() {
        this.swiper.slideNext();
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    this.author = this.authors[this.$route.query.m];
    this.author.id = this.$route.query.m;
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='css' scoped>
    @font-face {
        font-family: "simkai";
        src: url(../../assets/SIMKAI.ttf);
    }
.container {
    width:100%;
    height:306.67vw;
    background-size:100% auto;
    overflow:hidden;
    background-repeat:no-repeat;
}
.back {
        position:absolute;
        width:12.8vw;
        top:0;
        left:2vw;
    }
.avatar {
    position:relative;
    width:55vw;
    height: 42vw;
    margin: 9vw auto 20vw;
    display:flex;
    justify-content:center;
    align-items:center;
}
.avatar .photo {
    width:100%;
}
.avatar .name {
    position:absolute;
    top:-1vw;
    right:-1vw;
    display:block;
    width:9.06vw;
    height:28.13vw;
    background:url(../../assets/img/bg_name.png)center top/100% no-repeat;
    display:flex;
    flex-direction: column;
    justify-content: center;
    font-size:4.8vw;
    text-align:center;
    padding-top:3vw;
    font-family: "simkai";
    color:#0e0906;
}
.content {
    width:80%;
    margin:0 auto;
}
.content p {
    font-family: "kaiti";
    font-size:3.7vw;
    line-height:1.5;
    color:#0e0906;
    text-indent:2em;
    margin-bottom:10px;
    text-align: justify;
}
.work {
    margin:20vw auto;
}
.work .tit {
    width:42.6vw;
    margin:0 auto 10vw;
}
.list {
    width:93.4vw;
    margin:0 auto;
    background-size:100% auto;
    background-repeat: no-repeat;
    
}
.list .swiper {
    position:relative;
    width:78.9vw;
    height:59vw;
    margin:0 auto;
}
.list .swiper .swiperContainer {
    width:78.9vw;
    height:59vw;
    margin:0 auto;
    overflow:hidden;
}
.list .swiper .swiperContainer .btn {
    display:none;
}
.list .swiper  .btn {
    position:absolute;
    width:7.7vw;
    height:7.7vw;
    background:url(../../assets/img/prev.png)center/100% no-repeat;
}
.list .swiper  .btn.swiper-button-prev {
    left:-30px;
}
.list .swiper  .btn.swiper-button-next {
    right:-30px;
    transform:rotate(180deg)
}
.list  .item {
    width:12vw;
    height:47.86vw;
    background:url(../../assets/img/work_bg.png)center/100% no-repeat;
    font-family: "kaiti";
    font-size:4.8vw;
    color:#0e0906;
    writing-mode: vertical-rl;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    float:left;
    margin:0 3.3vw;
    position:relative;
    top:7vw;
}
.list  .item:after {
    position:absolute;
    top:-7vw;
    left:0;
    content:"";
    display:block;
    width:100%;
    height:7vw;
    background:url(../../assets/img/work-ico.png)center bottom no-repeat;
    background-size:1.86vw auto;
}
.list  .item.odd {
    top:4vw;
}
.list  .item.odd:after {
    height:4vw;
    top:-4vw;
}
</style>


// WEBPACK FOOTER //
// src/pages/author/index.vue